var map = {
	"./part1_1.png": "9Hux",
	"./part1_2.png": "/weS",
	"./part1_3.png": "5ecC",
	"./part1_4.png": "/vQu",
	"./part1_5.png": "R3Ct",
	"./part1_6.png": "nS+v",
	"./part1_7.png": "j1A4",
	"./part1_8.png": "8alH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Nmdl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report ^\.\/part1_.*\.png$
// module id = Nmdl
// module chunks = 1